// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useServicesOptions = () => {
  const { options } = useStaticQuery(graphql`
    query ServicesOptions {
      options: wp(global: {}) {
        global {
          services {
            heading: servicesHeading
            backgroundImage: servicesBackgroundImage {
              altText
              gatsbyImage(width: 1920, placeholder: NONE)
              localFile {
                publicURL
              }
              mediaDisplayOptions {
                filter
              }
            }
            coreBoxes: coreServicesBoxes {
              heading
              text
              buttons {
                button {
                  target
                  title
                  url
                }
              }
            }
            additionalBoxes: additionalServicesBoxes {
              heading
              text
              buttons {
                button {
                  target
                  title
                  url
                }
              }
            }
          }
          seoPageServices {
            heading: seoPageServicesHeading
            boxes: seoPageServicesBoxes {
              heading
              text
              buttons {
                button {
                  target
                  title
                  url
                }
              }
            }
          }
        }
      }
    }
  `);

  return options?.global;
};

export default useServicesOptions;
